import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Home } from 'lucide-react';

const HomeButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const getHomePath = () => {
    if (!user || !user.rol) {
      return '/';
    }
    
    switch (user.rol) {
      case 'administrador':
        return '/admin/dashboard';
      case 'tecnico':
        return '/tecnico';
      case 'cliente':
        return '/cliente';
      default:
        return '/';
    }
  };

  return (
    <Button
      variant="outline"
      onClick={() => navigate(getHomePath())}
      className={className}
      data-testid="home-button"
    >
      <Home className="mr-2 h-4 w-4" />
      Inicio
    </Button>
  );
};

export default HomeButton;
